import {
  FETCH_NEW_INTERVENTIONS_DOCTORS_SUCCESS,
  SHOW_NEW_INTERVENTIONS_LOADER,
  SHOW_NEW_INTERVENTIONS_MESSAGE,
  SHOW_NEW_INTERVENTIONS_SAVE_LOADER,
  HIDE_NEW_INTERVENTIONS_MESSAGE
} from 'constants/ActionTypes';

const INIT_STATE = {
  loader: true,
  saving: false,
  alertMessage: '',
  showMessage: false,
  isErrorMessage: false,
  doctors: []
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_NEW_INTERVENTIONS_DOCTORS_SUCCESS: {
      return {
        ...state,
        doctors: action.payload,
        loader: false,
      }
    }
    case SHOW_NEW_INTERVENTIONS_LOADER: {
      return {
        ...state,
        loader: true,
      }
    }
    case SHOW_NEW_INTERVENTIONS_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload.message,
        isErrorMessage: action.payload.messageStatus,
        showMessage: true,
        loader: false,
        saving: false
      }
    }
    case SHOW_NEW_INTERVENTIONS_SAVE_LOADER: {
      return {
        ...state,
        saving: true,
      }
    }
    case HIDE_NEW_INTERVENTIONS_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        isErrorMessage: false,
        showMessage: false,
        loader: false,
        saving: false
      }
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/NewInterventions.js